import { render } from "./ord-node.vue?vue&type=template&id=084f22a9"
import script from "./ord-node.vue?vue&type=script&lang=js"
export * from "./ord-node.vue?vue&type=script&lang=js"

import "./ord-node.vue?vue&type=style&index=0&id=084f22a9&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__